import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

export const Label = styled.span`
  margin-right: 1rem;
  white-space: nowrap;
  font-size: 0.875rem;

  @media only screen and (max-width: 665px) {
    display: none;
  }
`;

export const Burger = styled.span`
  top: 50%;
  z-index: 1;
  transform: translateY(-50%);
  transform-origin: center center;
  position: absolute;
  right: 0;
  display: block;
  position: absolute;
  background-color: ${props =>
    props.isOpen ? 'transparent' : themeGet('colors.black')};
  border-radius: ${props => props.borderRadius};
  height: ${props => props.height};
  width: ${props => props.width};
  transition: background-color ${props => props.duration}
    ${props => props.timingFunction} 0;
`;

export const Bun = styled.span`
  position: absolute;
  right: 0;
  display: block;
  transform-origin: center center;
  z-index: 2;
  background-color: ${themeGet('colors.black')};
  border-radius: ${props => props.borderRadius};
  height: ${props => props.height};
  width: ${props => props.width};
  transition:
    top ${props => props.duration} ${props => props.timingFunction}
      ${props => props.delay},
    transform ${props => props.duration} ${props => props.timingFunction}
      ${props => props.delay};
  &:first-of-type {
    top: ${props => (props.isOpen ? 50 : 0)}%;
    transform: ${props =>
      props.isOpen ? 'translateY(-50%) rotate(-45deg)' : ''};
  }
  &:last-of-type {
    top: ${props => (props.isOpen ? 50 : 100)}%;
    transform: ${props =>
      props.isOpen ? 'translateY(-50%) rotate(45deg)' : 'translateY(-100%)'};
  }
`;

export const Wrapper = styled.span`
  position: relative;
  display: inline-block;
  height: ${props => props.height};
  width: ${props => props.width};
  /* outline: 0; */
  text-indent: -99999px;
`;

export const Btn = styled.button.attrs(() => ({
  type: 'button',
}))`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  margin-left: 0.5rem;
  ${Label} & {
    color: ${themeGet('colors.black')};
    &:focus,
    &:hover {
      color: ${themeGet('colors.pc-red', '#E1251B')};
    }
  }

  &:focus,
  &:hover {
    span {
      color: ${themeGet('colors.pc-red', '#E1251B')};
      span {
        background-color: ${themeGet('colors.pc-red', '#E1251B')};
      }
    }
  }
`;
